<script>
  import { createEventDispatcher } from 'svelte'
  import ImageGallery from '../../components/ImageGallery'
  import ImageThumbnailGallery from '../../components/ImageThumbnailGallery'
  import Button from '../../components/Button'
  import { EntryPreviewCard, EntryInline } from '../entries'

  export let waypoint
  export let pageHeading = false
  export let centred = false
  export let showDate = true
  export let maxVisibleEntries = null
  export let useInlineGallery = false
  export let hideSeparateEntries = false

  const dispatch = createEventDispatcher()
  const VIEWS = {
    CONTENT: 'content',
    GALLERY: 'gallery'
  }

  let view = VIEWS.CONTENT
  $: galleryAvailable = waypoint.hasImages()
  $: candidateEntries = hideSeparateEntries ? waypoint.concurrentEntries : waypoint.entries
  $: visibleEntries = (maxVisibleEntries && candidateEntries)
      ? candidateEntries.slice(0, maxVisibleEntries)
      : candidateEntries
  $: inlineEntries = visibleEntries.filter(entry => entry.display.inline)
  $: cardEntries = visibleEntries.filter(entry => !entry.display.inline)

  const toggleGallery = () => {
    view = view === VIEWS.CONTENT ? VIEWS.GALLERY : VIEWS.CONTENT
  }
</script>

<div class="waypoint-content" class:centred>
  {#if showDate}
    <span class='h4 waypoint-date'>{waypoint.whenString}</span>
  {/if}

  {#if waypoint.title || (useInlineGallery && galleryAvailable)}
  <div class="header">
    {#if pageHeading}
      <h1 class="h2 heading">{waypoint.title}</h1>
    {:else}
      <h2 class="heading">{waypoint.title}</h2>
    {/if}

    {#if useInlineGallery && galleryAvailable}
      <Button on:click={toggleGallery} variant="secondary-outline">
        View { view === VIEWS.CONTENT ? 'gallery' : 'entries'}
      </Button>
    {/if}
  </div>
  {/if}

  {#if view === VIEWS.CONTENT }
    {#if waypoint.hasImages()}
      <div class="thumbnail-gallery-container">
        <ImageThumbnailGallery images={waypoint.images} galleryLink={!useInlineGallery} />
      </div>
    {/if}

    {#if inlineEntries.length > 0}
      <div class="entries-inline-wrapper">
        {#each inlineEntries as entry}
          <EntryInline {entry} />
        {/each}
      </div>
    {/if}

    {#if cardEntries.length > 0}
      <div class="entry-preview-cards-wrapper">
        {#each cardEntries as entry}
          <div class="entry-preview-card-wrapper">
            <EntryPreviewCard {entry} on:click={() => dispatch('entry-click', entry)}/>
          </div>
        {/each}
      </div>
    {/if}
  {/if}

  {#if view === VIEWS.GALLERY}
    <ImageGallery images={waypoint.images} />
  {/if}
</div>

<style>
  .waypoint-content {
    max-width: var(--media-md);

    display: flex;
    flex-direction: column;
    gap: var(--spacer-lg);
  }

  .waypoint-content.centred {
    margin: 0 auto;
  }

  .thumbnail-gallery-container {
    width: 100%;
    height: 6rem;
    margin-block-end: var(--spacer-sm);
  }

  .header {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: var(--spacer-xl);
  }

  .header .heading {
    flex-shrink: 1;
    margin-top: 0;
    margin-bottom: 0;
  }

  .waypoint-date {
    margin: 0;
  }

  .entry-preview-cards-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: var(--spacer-md);
  }

  .entry-preview-card-wrapper {
    flex-basis: 100%;
    flex-grow: 1;
    flex-shrink: 1;
    max-height: 8em;
  }
</style>
